var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgValuePropHouse = function SvgValuePropHouse(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5007 10.5L8.99923 15.0015L9.00073 4.5H13.5007V10.5ZM41.9992 33V22.362L45.8182 26.181L48.0007 24L24.0007 0L16.5007 7.5015L16.4947 1.5H6.00073V18L0.000732422 24L2.18173 26.181L6.00073 22.362L5.99923 48H41.9992L42.0007 39H39.0007V45H8.99923V19.3635L24.0007 4.362L39.0007 19.362L38.9992 33H41.9992Z",
    fill: "#151515"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.2652 35.8564L14.1212 42.0004L12.0002 39.8794L18.0137 33.8659C16.7702 32.3209 16.0232 30.3634 16.0232 28.2274C16.0232 23.2564 20.0522 19.2274 25.0232 19.2274C29.9927 19.2274 34.0232 23.2564 34.0232 28.2274C34.0232 33.1969 29.9927 37.2274 25.0232 37.2274C23.2727 37.2274 21.6467 36.7204 20.2652 35.8564ZM31.0232 28.2274C31.0232 24.9184 28.3322 22.2274 25.0232 22.2274C21.7142 22.2274 19.0232 24.9184 19.0232 28.2274C19.0232 31.5349 21.7142 34.2274 25.0232 34.2274C28.3322 34.2274 31.0232 31.5349 31.0232 28.2274Z",
    fill: "#0157FF"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgValuePropHouse);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "value_prop_house.6984f660073eb063ff6677ea50f93398.svg";